function PlusIcon({ width = 16, height = 16 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.56667 14.2332C11.2486 14.2332 14.2333 11.2485 14.2333 7.56657C14.2333 3.88467 11.2486 0.899902 7.56667 0.899902C3.88477 0.899902 0.900002 3.88467 0.900002 7.56657C0.900002 11.2485 3.88477 14.2332 7.56667 14.2332Z"
                stroke="#2D72D2"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.9 7.56657H10.2333M7.56667 4.8999V10.2332"
                stroke="#2D72D2"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokestrokelinejoin="round"
            />
        </svg>
    );
}

export default PlusIcon;
